module.exports = __webpack_public_path__ + "static/media/sub-footer_image.6d4723ac.jpg";